import * as React from 'react';
import { IRangeSliderProps, NumberRange, RangeSlider } from '@blueprintjs/core';

export interface ICategoryTreeRangeProps extends IRangeSliderProps {

}

const CategoryTreeRange: React.FunctionComponent<ICategoryTreeRangeProps> = (props) => {
    const [value, setValue] = React.useState<NumberRange>(props.value || [0, 0]);

    React.useEffect(() => {
        setValue(props.value || [0, 0]);
    }, [props.value]);

    // Main output
    return (
        <RangeSlider
            showTrackFill={true}
            min={props.min}
            max={props.max}
            value={value}
            stepSize={props.stepSize}
            labelStepSize={props.max}
            labelPrecision={0}
            onChange={setValue}
            onRelease={props.onRelease}
        />
    );
};

CategoryTreeRange.displayName = 'CategoryTreeRange';

export default CategoryTreeRange;
